"use client";
import {
  CompositeContextProvider,
  CompositeScopedContextProvider
} from "./TN5Y26CD.js";
import {
  createStoreContext
} from "./PTCNA5XT.js";

// src/radio/radio-context.tsx
var ctx = createStoreContext(
  [CompositeContextProvider],
  [CompositeScopedContextProvider]
);
var useRadioContext = ctx.useContext;
var useRadioScopedContext = ctx.useScopedContext;
var useRadioProviderContext = ctx.useProviderContext;
var RadioContextProvider = ctx.ContextProvider;
var RadioScopedContextProvider = ctx.ScopedContextProvider;

export {
  useRadioContext,
  useRadioScopedContext,
  useRadioProviderContext,
  RadioContextProvider,
  RadioScopedContextProvider
};
